import React, { useState, useContext, useEffect, useRef } from 'react'
import "./CompanyDetail.css"
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { Loading, HeaderTitle, Checkbox } from '../Library'
import { addCompany } from '../Network/Company'
import { addDepartment } from '../Network/Department'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'
import { listFloor } from '../Network/Floor'
import { RoleContext } from '../Role/RoleContext'
import axios from 'axios'
import { NetworkCellOutlined } from '@material-ui/icons'

function AddCompany() {
    const roleCx = useContext(RoleContext)
    const notify = useContext(NotifyContext);
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [company, setCompany] = useState("");
    const [companyEn, setCompanyEn] = useState("")
    const [acronym, setAcronym] = useState("");
    const [branch, setBranch] = useState("");
    const [branchCode, setBranchCode] = useState("");
    const [location, setLocation] = useState("");
    const [officePhone, setOfficePhone] = useState("");
    const [type, setType] = useState("OFFICE")
    const [floor, setFloor] = useState(false)
    const [isInformation, setIsInformation] = useState(false)
    const [isError, setError] = useState(false);
    const hiddenFileInput = useRef(null);
    const [logoImage, setLogoImage] = useState({preview: "", raw: "" }); 

    const typeList = [
        { value: "OFFICE", label: lang.office },
        { value: "RETAIL", label: lang.retail }
    ]
    const [floorList, setFloorList] = useState([])

    const [departmentName, setDepartmentName] = useState("");
    const [toAddDepartment, setDepartment] = useState([]);
    const [isSelectedRetail, setIsSelectedRetail] = useState(false);

    const onSubmit = () =>{
        if(!company || !companyEn || !acronym || !branch || !branchCode || !location || !officePhone){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1);
            setError(true);
            return;
        }
        
        setLoading(true)
        addCompany(company, companyEn, acronym, branch, branchCode, location, officePhone, type, floor, isInformation,
            async (data)  =>{
                if(logoImage.raw)
                {
                    const formData = new FormData();
                    formData.append("store_id", data.id);
                    formData.append("image", logoImage.raw);
                    const responseData = await axios.post('https://wtc.co.th:8080/update_storelogo', formData);
                    console.log(responseData);
                }
                submitDepartment(data.id);
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2);
            })
    }

    const submitDepartment = (id) =>{
        if(toAddDepartment.length > 0){
            toAddDepartment.forEach((item)=>{
                addDepartment(item, id,
                    ()=>{ },
                    (error)=>{
                        notify.showNotify("Something wrong", error.message, 2);
                    })
            })
            notify.showNotify(lang.added_company, lang.added_company_desc, 0);
            setLoading(false);
            history.push("/company");
        }else{
            notify.showNotify(lang.added_company, lang.added_company_desc, 0);
            setLoading(false)
            history.push("/company")
        }
    }

    const addDepartmenttoList = () =>{
        if(departmentName === ""){ return; }
        setDepartment([...toAddDepartment, departmentName])
        setDepartmentName("")
    }

    const removeDepartment = (name) =>{
        setDepartment(toAddDepartment.filter(item=> item !== name))
    }

    const handleRetail = () => {
        hiddenFileInput.current.click();
    };

    const handleChangeRetail = (event) => {
        setLogoImage({
            preview: URL.createObjectURL(event.target.files[0]),
            raw: event.target.files[0]
          });
        console.log(event.target.files[0]);
    };

    useEffect(()=>{
        const fetchFloorList = () => {
            listFloor(
                (data) => {
                    setFloorList(data)
                },
                (error) => {  }
            )
        }
        fetchFloorList()
        setDocumentTitle("Add company")
    },[])

    return (
        <>
        { isLoading ? <Loading title="Adding company"/> : null }
        <div id="add-company">
            <div className="header-content">
                <HeaderTitle
                    title={lang.add_company}
                    isShowBack
                    backTo="/company"
                />
                <Button type='file' variant="success" style={{fontSize:'20px'}} disabled={!isSelectedRetail} onClick={handleRetail} >เพิ่มโลโก้ร้านค้า</Button>
                <input type='file' accept='image/*'  style={{display:'none'}} ref={hiddenFileInput} onChange={handleChangeRetail}/>
            </div>
            <Form
             onSubmit={(e)=>{
                 e.preventDefault();
                 onSubmit();
             }}
             >
                <Row style={{width: "100%"}}>
                    <Col className="content-container" lg={6} xl={6}>
                    
                        <Form.Group>
                            <Form.Label>{lang.company_name}</Form.Label>
                            <Form.Control
                            value={company}
                            isInvalid={isError && !company}
                            onChange={(e)=>setCompany(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.company_name_en}</Form.Label>
                            <Form.Control
                            value={companyEn}
                            isInvalid={isError && !companyEn}
                            onChange={(e)=>setCompanyEn(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.acronym}</Form.Label>
                            <Form.Control
                            value={acronym}
                            isInvalid={isError && !acronym}
                            onChange={(e)=>setAcronym(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.branch}</Form.Label>
                            <Form.Control
                            value={branch}
                            isInvalid={isError && !branch}
                            onChange={(e)=>setBranch(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.branch_code}</Form.Label>
                            <Form.Control
                            value={branchCode}
                            isInvalid={isError && !branchCode}
                            onChange={(e)=>setBranchCode(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.location}</Form.Label>
                            <Form.Control
                            value={location}
                            isInvalid={isError && !location}
                            onChange={(e)=>setLocation(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.office_phone}</Form.Label>
                            <Form.Control
                            value={officePhone}
                            isInvalid={isError && !officePhone}
                            onChange={(e)=>setOfficePhone(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.type}</Form.Label>
                            <Form.Control 
                            as="select"
                            value={type}
                            onChange={(e)=>{
                                setType(e.target.value);
                                e.target.value == 'RETAIL'? setIsSelectedRetail(true):setIsSelectedRetail(false)
                            }}
                            >
                                { typeList.map((item, key) =>
                                <option value={item.value} key={key}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{`${lang.floor} (${lang.optional})`}</Form.Label>
                            <Form.Control 
                            as="select"
                            value={floor}
                            onChange={(e)=> setFloor(e.target.value)}>
                                <option value="">{lang.select_floor}</option>
                                { floorList.map((item, key) =>
                                <option value={item.id} key={key}>{item.floorName}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        
                        { roleCx.checkPermission('_MENU_', 'app.front_screen') ?
                        <Form.Group>
                            <Checkbox
                            checked={isInformation}
                            onChange={()=>setIsInformation(!isInformation ? true : false)} 
                            label={
                                <div className='optional-checkbox'>
                                    <FontAwesomeIcon icon={faWindowMaximize} className='icon'/>
                                    <div>
                                        <div className="title"><b>{lang.display_on_information_screen}</b></div>
                                        <div className="desc">{lang.display_on_information_screen_desc}</div>
                                    </div>
                                </div>
                                
                            }/>
                        </Form.Group>
                        : null
                        }
                        { isSelectedRetail?
                            <Form.Group>
                                <div>
                                    <div className='header-preview-retail'>ตัวอย่างโลโก้ร้านค้า</div>
                                    <img className='img-preview-retail' src={logoImage.preview}/>
                                </div>
                            </Form.Group>
                            :null
                        }
                        <hr/>
                        
                    
                    </Col>
                    <Col lg={6} xl={6}>
                        <div>
                            <div><b>{lang.add_department}</b></div>
                        </div>
                        <div className="department-container">
                            <div className="add-depart">
                                <Form.Control
                                placeholder={lang.enter_department}
                                value={departmentName}
                                onChange={(e)=>setDepartmentName(e.target.value)}
                                />
                                <Button variant="success"
                                onClick={()=>addDepartmenttoList()}
                                >
                                    <FontAwesomeIcon icon={faPlus}/>
                                </Button>
                            </div>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{lang.department}</th>
                                        <th>{lang.action}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { toAddDepartment.length > 0 ?
                                    <>
                                    { toAddDepartment.map((item, key)=>
                                    <tr key={key}>
                                        <td>{item}</td>
                                        <td style={{textAlign: "center"}}>
                                            <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={()=>removeDepartment(item)}>
                                                <FontAwesomeIcon
                                                icon={faTrash}/>
                                            </Button>
                                        </td>
                                    </tr>
                                    )}
                                    </>:
                                    <tr>
                                        <td colSpan="2" style={{textAlign: 'center'}}>
                                            {lang.no_department}
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
                <Button type="submit" style={{marginTop: 20}}>
                    {lang.add_company}
                </Button>
            </Form>
        </div>
        </>
    )
}

export default AddCompany
